/*eslint-diasble*/
import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import jwtDecode from "jwt-decode";
import "../assets/styles/Login.css";
import { AdminLogin } from "../api/AuthenticationServices";
import { getProtectedData } from "../api/ProtectedRoute";
// import { setToken } from "../store/action";
// import { connect } from "react-redux";
// var Ltoken;
const Login = (props) => {
  const navigate = useNavigate();
  const [username, setuserName] = useState("");
  const [password, setPassword] = useState("");
  
  
  const loginToken = localStorage.getItem("authorizeToken");
  
  if (loginToken) {
    try {
      // Step 2: Verify the JWT on the client-side
      const decoded = jwtDecode(loginToken);
      const currentTime = Date.now() / 1000;

      if (decoded.exp < currentTime) {
        // JWT has expired, so remove it from storage and redirect to login page
        localStorage.removeItem("authorizeToken");
        // window.location.href = "/login";
      } else {
        // JWT is still valid, so set it as an authentication header for all requests
        axios.defaults.headers.common["Authorization"] = `Bearer ${loginToken}`;
        // Ltoken = token;
        // props.setToken("loginToken");
        // dispatch(setToken(token));

        getProtectedData(loginToken)
          .then((data) => {
            window.location.href = "/admin";
         
          })
          .catch((error) => {
            console.error("Error fetching protected data:", error);
          });
      }
    } catch (error) {
      // JWT is invalid, so remove it from storage and redirect to login page
      localStorage.removeItem("authorizeToken");
      // window.location.href = "/login";
    }
  }

  const sendData = async () => {
    try {
      const data = {
        adminEmail: username,
        adminPassword: password,
      };
      const res = await AdminLogin(data);
      if (res.data.status === "success") {
        // navigate(`/admin`);
        window.location.href = "/admin";
        localStorage.setItem("authorizeToken", res.data.token);
        axios.defaults.headers.common["Authorization"] = `Bearer ${loginToken}`;
      } else {
        if (
          res.data.status === "failed" &&
          res.data.message === "credentials available"
        ) {
          window.location.href = "/admin";

          // navigate(`/admin`);
        } else {
          alert("Failed due to following reason : " + res.data.message);
        }
      }
    } catch (error) {
      alert("Error! " + error.response.data.message);
      navigate(`/login`);
      console.log(error);
    }
  };

  return (
    <div className="loginbody">
      <div className="box">
        <div className="form">
          <h2>Sign in</h2>
          <div className="inputBox">
            <input
              type="text"
              required="required"
              value={username}
              onChange={(e) => setuserName(e.target.value)}
            />
            <span>Username</span>
            <i></i>
          </div>
          <div className="inputBox">
            <input
              type="password"
              required="required"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <span>Password</span>
            <i></i>
          </div>

          <input
            className="inputSubmit"
            type="submit"
            value="Login"
            onClick={sendData}
          ></input>
        </div>
      </div>
    </div>
  );
};

// const mapStateToProps = (state) => {
//   console.log("State to props : ", state);
//   return {
//     loginToken: state.loginToken,
//   };
// };

// const mapDispatchToProps = (dispatch) => {
//   return {
//     setToken: (loginToken) => {
//       console.log("Dispatch Area : ", loginToken);
//       dispatch(setToken(loginToken));
//     },
//   };
// };
export default Login;
